import React, { useRef, useCallback, useState, useEffect } from 'react';
import { MainContainer } from 'components/shared';
import * as S from './styles';
import { FetchEmbedZohoActions } from 'store/ducks/zohoDashboard';
import { useDispatch, useSelector } from 'react-redux';

export const Scheduling: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const dispatch = useDispatch();
  
  const handleClick = useCallback(() => {
    if (ref.current) {
      if (window.document.fullscreenElement) {
        if (window.document.exitFullscreen) {
          window.document.exitFullscreen();
        }
      } else {
        ref.current.requestFullscreen();
      }
    }
  }, []);

  const handleKeyDown = useCallback(() => {
    setIsFullscreen((v) => !v);
  }, []);

  useEffect(() => {
    if (window.document) {
      window.document.addEventListener('fullscreenchange', handleKeyDown);
    }

    return () => {
      window.document.removeEventListener('fullscreenchange', handleKeyDown);
    };
  }, [handleKeyDown]);

  const getDashboardUrl = useCallback((view: string) => {
    dispatch(FetchEmbedZohoActions.request(view));
  }, [dispatch])

  const { data: zohoEmbedUrl , loading } = useSelector(
    (state:any) => state.fetchEmbedZohoUrl
  );

  useEffect(() => {
    //getDashboardUrl(''); //inserir o id/view da dashboard e descomentar o iframe abaixo
  }, []);

  return (
    <MainContainer>
      <S.Container ref={ref}>
        <S.Button onClick={handleClick}>
          {isFullscreen ? <S.IconExitFullscreen /> : <S.IconFullscreen />}
        </S.Button>
        {/* {
          loading ? (
            <S.Loading />
          ) : (
             <S.Iframe
              width="100%"
              height="100%"
              src={zohoEmbedUrl?.data?.embedUrl}
            /> 
          )
        } */}  
        <S.Iframe
          width="100%"
          height="100%"
          src="https://analytics.zoho.com/open-view/1432280000129153761/477b9228c904c39bd67d368d4608fe49"
        />
      </S.Container>
    </MainContainer>
  );
};
